import { ACCESS_STATUSES } from "../../providers/ViewerProvider";
export var getTextByStatus = function (status) {
    switch (status) {
        case ACCESS_STATUSES.demo:
            return "360° Demo";
        case ACCESS_STATUSES.ordered:
        case ACCESS_STATUSES.content:
            return "360°";
        default:
            return null;
    }
};
